exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-verify-optv[data-v-fd3440da] {\n  width: 70% !important;\n  margin: 5px auto !important;\n}\n", ""]);

// exports
